var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 34.5V31.5C15.6 28.7 12.8 26.5 10 26.5C7.2 26.5 4.4 28.7 4.4 31.5V34.5C3.2 34.5 2 35.7 2 36.9V43.9C2 45.3 3.2 46.5 4.4 46.5H15.4C16.8 46.5 18 45.3 18 44.1V37.1C18 35.7 16.8 34.5 15.6 34.5ZM13 34.5H7V31.5C7 29.9 8.4 28.9 10 28.9C11.6 28.9 13 29.9 13 31.5V34.5ZM42 6.5H22L6 22.5V23.38C7.22 22.84 8.58 22.5 10 22.5C15.2 22.5 19.6 26.62 19.6 31.5V32C21.06 33.22 22 35.06 22 37.1V42.5H44V8.5C44 7.4 43.1 6.5 42 6.5ZM38 32.5H32V28.5H38V32.5ZM40 22.5H11.66L23.66 10.5H40V22.5Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLock);
export default __webpack_public_path__ + "static/media/aboutLock.a47901086a1486be02d84ddbcaf4bf72.svg";
export { ForwardRef as ReactComponent };